export function RSScheduleService($http, apexApiUrl) {
    'ngInject'
    return {
        retrieveRSSchedules: retrieveRSSchedules,
        retrieveRSSchedulesPaged: retrieveRSSchedulesPaged,
        retrieveRSSchedule: retrieveRSSchedule,
        updateRSSchedule: updateRSSchedule,
        retrieveRSScheduleEmployees: retrieveRSScheduleEmployees,
        retrieveQualifyingEmployees: retrieveQualifyingEmployees,
        saveRSScheduleEmployees: saveRSScheduleEmployees,
        retrieveEmployeeSchedules: retrieveEmployeeSchedules,
        retrieveEmployeePrograms: retrieveEmployeePrograms,
        retrieveEmployeeLocations: retrieveEmployeeLocations,
        retrieveEmployeeDepartments: retrieveEmployeeDepartments,
        retrieveRotationByDate: retrieveRotationByDate,
    };

    function retrieveRSSchedules(params) {
        return $http({
            method: "GET",
            url: apexApiUrl + "rs-schedules",
            responseType: "application/json",
            params: params
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveRSSchedulesPaged(pageIndex, params) {
        return $http({
            method: "GET",
            url: apexApiUrl + "RSSchedule/page/" + pageIndex,
            responseType: "application/json",
            params: params
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Retrieve the specific schedule details for the schedule with the given ID.
     */
    function retrieveRSSchedule(rsScheduleID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "rsschedule/" + rsScheduleID,
            headers: { 'Content-Type': 'application/json' },
            responseType: "application/json"
        }).then(function (response) {
            return response.data;
        })
    }

    function updateRSSchedule(rsSchedule) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "rsschedule/" + rsSchedule.RSScheduleID,
            headers: { 'Content-Type': 'application/json' },
            data: JSON.stringify({
                StartDate: rsSchedule.StartDate,
                EndDate: rsSchedule.EndDate,
                RSScheduleSales: rsSchedule.RSScheduleSales.map(function (sales) {
                    return {
                        RSScheduleSalesID: sales.RSScheduleSalesID,
                        SalesAmount: sales.SalesAmount,
                        AnonymousHours: sales.AnonymousHours
                    }
                })
            })
        });
    }

    function retrieveRSScheduleEmployees(rsScheduleID) {
        return $http({
            method: "POST",
            url: "/RSSchedule/ListRSScheduleEmployees/",
            headers: { 'Content-Type': 'application/json' },
            responseType: "application/json",
            data: JSON.stringify({ rsScheduleID: rsScheduleID }),
        });
    }

    function retrieveQualifyingEmployees(rsScheduleID) {
        return $http({
            method: "POST",
            url: "/RSSchedule/ListQualifyingEmployees/",
            headers: { 'Content-Type': 'application/json' },
            responseType: "application/json",
            data: JSON.stringify({ rsScheduleID: rsScheduleID }),
        });
    }

    function retrieveEmployeeSchedules(employeeID, icdOfficeID, scheduleDate) {
        return $http.get(apexApiUrl + "employees/" + employeeID + "/icd-offices/" + icdOfficeID + "/schedule-dates/" + scheduleDate.toString("yyyy-MM-dd"))
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Return the list of programs available for the given employee on the date,
     * in addition to their current selection and all programs if indicated.
     */
    function retrieveEmployeePrograms(employeeID, icdOfficeID, scheduleDate, selectedProgramID, showAll) {
        showAll = showAll || false;

        return $http({
            method: "GET",
            url: apexApiUrl + "employees/" + employeeID + "/icd-offices/" + icdOfficeID + "/schedule-dates/" + scheduleDate.toString("yyyy-MM-dd")
                + "/programs",
            responseType: "application/json",
            params: {
                selectedProgramID: selectedProgramID,
                showAll: showAll
            }
        })
            .then(function (response) {
                return response.data.map(function (program) {
                    return {
                        Value: program.Id,
                        Text: program.Name,
                        IsPinned: program.IsPinned
                    };
                });
            });
    }

    /**
     * Return the list of locations available for the given employee on the date,
     * in addition to their current selection and all locations if indicated.
     */
    function retrieveEmployeeLocations(employeeID, icdOfficeID, scheduleDate, selectedLocationID, showAll) {
        showAll = showAll || false;
        return $http({
            method: "GET",
            url: apexApiUrl + "employees/" + employeeID + "/icd-offices/" + icdOfficeID + "/schedule-dates/" + scheduleDate.toString("yyyy-MM-dd")
                + "/stores",
            responseType: "application/json",
            params: {
                selectedLocationID: selectedLocationID,
                showAll: showAll
            }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Return the list of locations available for the given employee on the date,
     * in addition to their current selection and all locations if indicated.
     */
    function retrieveEmployeeDepartments(employeeID, icdOfficeID, scheduleDate, selectedDepartmentID, showAll) {
        showAll = showAll || false;
        return $http(
            {
                method: "GET",
                url: apexApiUrl + "employees/" + employeeID + "/icd-offices/" + icdOfficeID + "/schedule-dates/" + scheduleDate.toString("yyyy-MM-dd")
                    + "/departments",
                responseType: "application/json",
                params: {
                    selectedDepartmentID: selectedDepartmentID,
                    showAll: showAll
                }
            })
            .then(function (response) {
                return response.data.map(function (dept) {
                    return {
                        Value: dept.Id,
                        Text: dept.Name
                    };
                });
            });
    }

    function retrieveRotationByDate(rsDate) {
        return $http({
            method: "GET",
            url: apexApiUrl + "rs-schedules/rotation-by-date/" + rsDate,
            headers: { 'Content-Type': 'application/json' },
            responseType: "application/json"
        }).then(function (response) {
            return response.data;
        })
    }

    function saveRSScheduleEmployees(rsScheduleID, employeeIDs) {
        return $http({
            method: "POST",
            url: "/RSSchedule/RSScheduleEmployees/" + rsScheduleID,
            headers: { 'Content-Type': 'application/json' },
            responseType: "application/json",
            data: JSON.stringify({ employeeIDs: employeeIDs }),
        });
    }
}
